module.exports = __webpack_public_path__ + "img/cinnamon-min.42456307.jpg";